import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MdOutlineSearch, MdOutlineSearchOff } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router'

export default function NavBarDesktopSearchButton() {
  const { lng } = useParams()
  const navigate = useNavigate()

  const { t } = useTranslation()

  const queryRef = useRef('')
  const [isOpen, setIsOpen] = useState(false)

  const handleToggleSearch = () => {
    setIsOpen(!isOpen)
  }

  const handleOnSubmitSearchForm = (event) => {
    event.preventDefault()
    if (queryRef.current.value === '') {
      return
    }
    navigate(`/${lng}/search/${queryRef.current.value}`)
    setIsOpen(false)
  }

  return (
    <>
      {isOpen && (
        <div
          onClick={handleToggleSearch}
          className="z-1 absolute bottom-0 left-0 top-0 h-screen w-full"
        />
      )}
      <div className="z-5 relative w-full">
        {isOpen && (
          <div className="absolute top-full mt-6 ltr:right-0 rtl:left-0">
            <form
              onSubmit={handleOnSubmitSearchForm}
              className="border-muted-300 relative flex border-2 bg-light p-2 ltr:flex-row-reverse"
            >
              <div className="absolute -top-2 h-3 w-3 rotate-45 border-l-2 border-t-2 bg-light ltr:right-3 rtl:left-3" />
              <input
                type="search"
                ref={queryRef}
                placeholder={`${t('SEARCH')}...`}
                className="w-[400px] border-2 px-2 py-1.5 font-normal outline-none"
                aria-label={t('SEARCH')}
                name="query"
              />
            </form>
          </div>
        )}
        <button
          onClick={handleToggleSearch}
          className="bg-secondary-600 border-secondary-600 hover:text-secondary-600 hover:bg-muted-300 border-2 p-1.5 px-2 text-white"
          aria-expanded={isOpen}
          aria-label={isOpen ? 'Close Search' : 'Open Search'}
          label={isOpen ? 'Close Search' : 'Open Search'}
        >
          {isOpen ? <MdOutlineSearchOff size={22} /> : <MdOutlineSearch size={22} />}
        </button>
      </div>
    </>
  )
}
